import React from 'react';
import {useTranslation} from '@wix/yoshi-flow-editor';
import {useControllerProps} from '../../../../../domain/controllers/ControllerContext';
import s from './Total/Total.scss';
import settingsParams from '../../../settingsParams';
import {useSettingsWithDefaults} from '../../../../../hooks/useSettingsWithDefaults';

export enum CartDisclaimersDataHook {
  CurrencyConverter = 'CartDisclaimers.CurrencyConverter',
  TaxIncluded = 'CartDisclaimers.TaxIncluded',
  Disclaimer = 'CartDisclaimers.Disclaimer',
}

export const CartDisclaimers = (): React.ReactNode => {
  const {t} = useTranslation();
  const {isPricesIncludeTax: pricesIncludeTax, shouldShowConversionDisclaimer} = useControllerProps().orderStore;
  const {
    cartModel: {businessInfo},
  } = useControllerProps().cartStore;
  const {getSettingsWithDefaults} = useSettingsWithDefaults();
  const cartDisclaimer = getSettingsWithDefaults(settingsParams.CART_V2_DISCLAIMER);

  if (!shouldShowConversionDisclaimer && !pricesIncludeTax && !cartDisclaimer) {
    return null;
  }

  return (
    <dl className={s.disclaimersRoot}>
      <dt>
        {shouldShowConversionDisclaimer && (
          <div data-hook={CartDisclaimersDataHook.CurrencyConverter} className={s.totalSubLabel}>
            {t('cart.currency_converter_disclaimer', {mainCurrency: businessInfo.currencyCode})}
          </div>
        )}

        {pricesIncludeTax && (
          <div data-hook={CartDisclaimersDataHook.TaxIncluded} className={s.totalSubLabel}>
            {t('cart.total.taxIncluded')}
          </div>
        )}

        {cartDisclaimer && (
          <div data-hook={CartDisclaimersDataHook.Disclaimer} className={s.totalSubLabel}>
            {cartDisclaimer}
          </div>
        )}
      </dt>
    </dl>
  );
};
